import * as z from "zod/v4";
import {
  getSelfServeOnboardingFunnelSteps,
  selfServeOnboardingFunnelStepsSchema,
} from "../onboardings/get-self-serve-onboarding-funnel-steps";
import { onboardingV2AnalyticsProductInputSchema } from "./analytics-product-id";

export const getOnboardingsV2FunnelSteps = {
  name: "getOnboardingsV2FunnelSteps" as const,
  input: z.intersection(
    getSelfServeOnboardingFunnelSteps.input,
    onboardingV2AnalyticsProductInputSchema,
  ),
  output: selfServeOnboardingFunnelStepsSchema,
};

export type GetOnboardingsV2FunnelStepsInput = z.infer<
  typeof getOnboardingsV2FunnelSteps.input
>;
export type GetOnboardingsV2FunnelStepsOutput = z.infer<
  typeof getOnboardingsV2FunnelSteps.output
>;
